import { Component } from '@angular/core';
import { BreadcrumbService } from '../../../core/services/breadcrumb/breadcrumb.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-administration',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './administration.component.html',
  styleUrl: './administration.component.css'
})
export class AdministrationComponent { }
